// DS: i5.6
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const SquareHeartFilled: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        width="0"
        height="0"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M11.584 1.136l2.92 1.703a1 1 0 01.496.864v4.421a1 1 0 01-.336.748l-6 5.333a1 1 0 01-1.328 0l-6-5.333A1 1 0 011 8.124v-4.42a1 1 0 01.496-.865l2.92-1.703a1 1 0 011.118.075L8 3.129l2.466-1.918a1 1 0 011.118-.075z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
SquareHeartFilled.displayName = 'SquareHeartFilled';

export default SquareHeartFilled;
